// Comprehensive Maternal Nutrition Data for 18 Global Cuisines
// Covers: Preconception, Trimester 1, Trimester 2, Trimester 3, and Postpartum stages

export const nutritionPlans = {
  // ========================================
  // PRECONCEPTION - All 18 Regions
  // ========================================
  
  preconception_West_African: { 
    foods: ['Dark leafy greens (Ugu)', 'Beans', 'Eggs', 'Fish', 'Whole grains'], 
    nutrients: ['Folic acid 400mcg', 'Iron', 'Calcium'], 
    avoid: ['Alcohol', 'Excess caffeine'], 
    meals: ['Breakfast: Akara with pap', 'Lunch: Bean porridge with fish', 'Dinner: Vegetable soup with fufu'] 
  },
  
  preconception_East_African: { 
    foods: ['Sukuma wiki', 'Beans', 'Eggs', 'Tilapia fish', 'Ugali', 'Teff'], 
    nutrients: ['Folic acid 400mcg', 'Iron', 'Calcium'], 
    avoid: ['Alcohol', 'Excess caffeine'], 
    meals: ['Breakfast: Mandazi with chai', 'Lunch: Githeri (beans and corn)', 'Dinner: Sukuma wiki with ugali'] 
  },
  
  preconception_North_African: { 
    foods: ['Couscous', 'Lentils', 'Chickpeas', 'Fish', 'Dates', 'Olive oil'], 
    nutrients: ['Folic acid 400mcg', 'Iron', 'Calcium'], 
    avoid: ['Alcohol', 'Excess caffeine'], 
    meals: ['Breakfast: Ful medames with bread', 'Lunch: Couscous with vegetables', 'Dinner: Tagine with chickpeas'] 
  },
  
  preconception_Southern_African: { 
    foods: ['Morogo (wild spinach)', 'Beans', 'Eggs', 'Fish', 'Maize meal'], 
    nutrients: ['Folic acid 400mcg', 'Iron', 'Calcium'], 
    avoid: ['Alcohol', 'Excess caffeine'], 
    meals: ['Breakfast: Pap with milk', 'Lunch: Morogo with pap', 'Dinner: Chakalaka with pap'] 
  },
  
  preconception_Middle_Eastern: { 
    foods: ['Lentils', 'Chickpeas', 'Yogurt', 'Eggs', 'Whole wheat bread'], 
    nutrients: ['Folic acid 400mcg', 'Iron', 'Calcium'], 
    avoid: ['Alcohol', 'Excess caffeine'], 
    meals: ['Breakfast: Foul medames with bread', 'Lunch: Lentil soup with yogurt', 'Dinner: Mujadara with salad'] 
  },
  
  preconception_South_Asian: { 
    foods: ['Spinach (palak)', 'Moong dal', 'Paneer', 'Eggs', 'Whole wheat roti'], 
    nutrients: ['Folic acid 400mcg', 'Iron', 'Calcium', 'Vitamin B12'], 
    avoid: ['Alcohol', 'Excess tea'], 
    meals: ['Breakfast: Poha with vegetables', 'Lunch: Dal with palak and roti', 'Dinner: Paneer curry with rice'] 
  },
  
  preconception_East_Asian: { 
    foods: ['Spinach', 'Tofu', 'Fish', 'Brown rice', 'Seaweed (nori)'], 
    nutrients: ['Folic acid 400mcg', 'Iron', 'Iodine'], 
    avoid: ['Alcohol', 'Raw fish'], 
    meals: ['Breakfast: Congee with century egg', 'Lunch: Stir-fried tofu with spinach', 'Dinner: Fish with brown rice'] 
  },
  
  preconception_Southeast_Asian: { 
    foods: ['Kangkung (water spinach)', 'Tempeh', 'Fish', 'Brown rice', 'Papaya'], 
    nutrients: ['Folic acid 400mcg', 'Iron', 'Vitamin C'], 
    avoid: ['Alcohol', 'Raw seafood'], 
    meals: ['Breakfast: Bubur ayam (rice porridge)', 'Lunch: Gado-gado with tempeh', 'Dinner: Grilled fish with rice'] 
  },
  
  preconception_Mexican: { 
    foods: ['Black beans', 'Nopales (cactus)', 'Eggs', 'Avocado', 'Corn tortillas'], 
    nutrients: ['Folic acid 400mcg', 'Iron', 'Fiber'], 
    avoid: ['Alcohol', 'Excess caffeine'], 
    meals: ['Breakfast: Huevos con nopales', 'Lunch: Frijoles with tortillas', 'Dinner: Tacos with beans'] 
  },
  
  preconception_South_American: { 
    foods: ['Black beans', 'Quinoa', 'Eggs', 'Avocado', 'Plantain'], 
    nutrients: ['Folic acid 400mcg', 'Iron', 'Protein'], 
    avoid: ['Alcohol', 'Excess caffeine'], 
    meals: ['Breakfast: Arepas with eggs', 'Lunch: Feijoada (bean stew)', 'Dinner: Quinoa with vegetables'] 
  },
  
  preconception_Central_American: { 
    foods: ['Black beans', 'Plantain', 'Eggs', 'Papaya', 'Corn'], 
    nutrients: ['Folic acid 400mcg', 'Iron', 'Vitamin C'], 
    avoid: ['Alcohol', 'Excess caffeine'], 
    meals: ['Breakfast: Gallo pinto with eggs', 'Lunch: Casamiento (rice and beans)', 'Dinner: Plantain with beans'] 
  },
  
  preconception_Caribbean: { 
    foods: ['Callaloo', 'Red peas', 'Fish', 'Green banana', 'Eggs'], 
    nutrients: ['Folic acid 400mcg', 'Iron', 'Calcium'], 
    avoid: ['Alcohol', 'Excess caffeine'], 
    meals: ['Breakfast: Callaloo with provision', 'Lunch: Rice and peas with fish', 'Dinner: Ackee and saltfish'] 
  },
  
  preconception_Mediterranean: { 
    foods: ['Spinach', 'Lentils', 'Sardines', 'Olive oil', 'Whole grains'], 
    nutrients: ['Folic acid 400mcg', 'Iron', 'Omega-3'], 
    avoid: ['Alcohol', 'Excess caffeine'], 
    meals: ['Breakfast: Greek yogurt with honey', 'Lunch: Horiatiki with lentil soup', 'Dinner: Grilled fish with vegetables'] 
  },
  
  preconception_UK_Irish: { 
    foods: ['Leafy greens', 'Fortified cereals', 'Salmon', 'Eggs', 'Berries'], 
    nutrients: ['Folic acid 400mcg', 'Vitamin D', 'Iron'], 
    avoid: ['Alcohol', 'Raw eggs'], 
    meals: ['Breakfast: Porridge with berries', 'Lunch: Jacket potato with beans', 'Dinner: Salmon with greens'] 
  },
  
  preconception_North_American: { 
    foods: ['Spinach', 'Fortified cereals', 'Salmon', 'Eggs', 'Berries'], 
    nutrients: ['Folic acid 400mcg', 'Vitamin D'], 
    avoid: ['Alcohol', 'Raw eggs'], 
    meals: ['Breakfast: Whole grain cereal', 'Lunch: Salmon salad', 'Dinner: Grilled chicken with quinoa'] 
  },
  
  preconception_Nordic: { 
    foods: ['Salmon', 'Herring', 'Rye bread', 'Lingonberries', 'Root vegetables'], 
    nutrients: ['Folic acid 400mcg', 'Omega-3', 'Vitamin D'], 
    avoid: ['Alcohol', 'Excess caffeine'], 
    meals: ['Breakfast: Rye bread with fish', 'Lunch: Salmon with vegetables', 'Dinner: Herring with potatoes'] 
  },
  
  preconception_Eastern_European: { 
    foods: ['Buckwheat', 'Beets', 'Eggs', 'Fish', 'Cabbage'], 
    nutrients: ['Folic acid 400mcg', 'Iron', 'Vitamin C'], 
    avoid: ['Alcohol', 'Excess caffeine'], 
    meals: ['Breakfast: Kasha with milk', 'Lunch: Borscht with bread', 'Dinner: Fish with buckwheat'] 
  },
  
  preconception_Pacific_Islander: { 
    foods: ['Taro leaves', 'Fish', 'Coconut', 'Sweet potato', 'Breadfruit'], 
    nutrients: ['Folic acid 400mcg', 'Iron', 'Vitamin A'], 
    avoid: ['Alcohol', 'Excess salt'], 
    meals: ['Breakfast: Taro with coconut milk', 'Lunch: Cooked fish with taro', 'Dinner: Sweet potato with fish'] 
  },

  // ========================================
  // TRIMESTER 1 - All 18 Regions
  // ========================================
  
  t1_West_African: { 
    foods: ['Ginger', 'Plantain', 'Eggs', 'Tilapia fish', 'Oranges', 'Pap'], 
    nutrients: ['Folic acid 600mcg', 'Iron', 'Vitamin B6'], 
    avoid: ['Raw bushmeat', 'Unpasteurized nono'], 
    meals: ['Breakfast: Pap with milk and ginger', 'Lunch: Boiled plantain with egg sauce', 'Dinner: Light vegetable soup'] 
  },
  
  t1_East_African: { 
    foods: ['Ginger tea', 'Bananas', 'Eggs', 'Tilapia', 'Mangoes'], 
    nutrients: ['Folic acid 600mcg', 'Vitamin B6', 'Iron'], 
    avoid: ['Raw meat', 'Unpasteurized milk'], 
    meals: ['Breakfast: Chai with mandazi', 'Lunch: Matoke (plantain stew)', 'Dinner: Uji porridge'] 
  },
  
  t1_North_African: { 
    foods: ['Mint tea', 'Dates', 'Eggs', 'Sardines', 'Couscous'], 
    nutrients: ['Folic acid 600mcg', 'Vitamin B6', 'Omega-3'], 
    avoid: ['Unpasteurized cheese', 'Raw eggs'], 
    meals: ['Breakfast: Msemen with honey', 'Lunch: Couscous with vegetables', 'Dinner: Light tagine'] 
  },
  
  t1_Southern_African: { 
    foods: ['Ginger', 'Butternut', 'Eggs', 'Fish', 'Maas (soured milk)'], 
    nutrients: ['Folic acid 600mcg', 'Vitamin B6', 'Calcium'], 
    avoid: ['Unpasteurized milk', 'Raw meat'], 
    meals: ['Breakfast: Soft pap with ginger', 'Lunch: Butternut soup', 'Dinner: Fish with vegetables'] 
  },
  
  t1_Middle_Eastern: { 
    foods: ['Ginger tea', 'Pita bread', 'Hummus', 'Dates', 'Labneh'], 
    nutrients: ['Folic acid 600mcg', 'Vitamin B6', 'Calcium'], 
    avoid: ['Unpasteurized cheese', 'Raw kibbeh'], 
    meals: ['Breakfast: Pita with labneh and za\'atar', 'Lunch: Lentil soup with mint', 'Dinner: Grilled chicken with rice'] 
  },
  
  t1_South_Asian: { 
    foods: ['Ginger (adrak)', 'Dry fruits', 'Coconut water', 'Khichdi', 'Curd (dahi)'], 
    nutrients: ['Folic acid 600mcg', 'Iron', 'Vitamin B6'], 
    avoid: ['Papaya', 'Ajinomoto', 'Street food'], 
    meals: ['Breakfast: Ginger tea with Marie biscuits', 'Lunch: Moong dal khichdi with curd', 'Dinner: Light sabzi with roti'] 
  },
  
  t1_East_Asian: { 
    foods: ['Ginger', 'Congee', 'Steamed fish', 'Seaweed', 'Soy milk'], 
    nutrients: ['Folic acid 600mcg', 'Iron', 'Iodine'], 
    avoid: ['Sashimi', 'High-mercury tuna'], 
    meals: ['Breakfast: Congee with preserved egg and ginger', 'Lunch: Steamed fish with ginger', 'Dinner: Vegetable noodle soup'] 
  },
  
  t1_Southeast_Asian: { 
    foods: ['Ginger', 'Bubur (rice porridge)', 'Steamed fish', 'Young coconut water'], 
    nutrients: ['Folic acid 600mcg', 'Vitamin B6', 'Hydration'], 
    avoid: ['Raw papaya', 'Raw seafood', 'Durian'], 
    meals: ['Breakfast: Bubur ayam with ginger', 'Lunch: Sinigang na isda (sour fish soup)', 'Dinner: Steamed vegetables with rice'] 
  },
  
  t1_Mexican: { 
    foods: ['Ginger water', 'Crackers', 'Nopales', 'Chicken broth', 'Avocado'], 
    nutrients: ['Folic acid 600mcg', 'Vitamin B6'], 
    avoid: ['Queso fresco', 'Raw chorizo'], 
    meals: ['Breakfast: Atole with crackers', 'Lunch: Caldo de pollo', 'Dinner: Soft tacos with chicken'] 
  },
  
  t1_South_American: { 
    foods: ['Ginger', 'Crackers', 'Bananas', 'Chicken soup', 'Avocado'], 
    nutrients: ['Folic acid 600mcg', 'Vitamin B6'], 
    avoid: ['Unpasteurized cheese', 'Raw meats'], 
    meals: ['Breakfast: Arepas with avocado', 'Lunch: Sancocho (chicken soup)', 'Dinner: Grilled chicken with rice'] 
  },
  
  t1_Central_American: { 
    foods: ['Ginger tea', 'Tortillas', 'Eggs', 'Black beans', 'Papaya (cooked)'], 
    nutrients: ['Folic acid 600mcg', 'Vitamin B6', 'Fiber'], 
    avoid: ['Raw papaya', 'Unpasteurized cheese'], 
    meals: ['Breakfast: Gallo pinto', 'Lunch: Sopa de frijoles', 'Dinner: Chicken with rice'] 
  },
  
  t1_Caribbean: { 
    foods: ['Ginger tea', 'Crackers', 'Green banana', 'Fish', 'Coconut water'], 
    nutrients: ['Folic acid 600mcg', 'Vitamin B6', 'Hydration'], 
    avoid: ['Raw fish', 'Unpasteurized juice'], 
    meals: ['Breakfast: Ginger tea with hardo bread', 'Lunch: Steamed fish with provision', 'Dinner: Chicken soup'] 
  },
  
  t1_Mediterranean: { 
    foods: ['Ginger', 'Crackers', 'Olives', 'Grilled fish', 'Lemon water'], 
    nutrients: ['Folic acid 600mcg', 'Omega-3', 'Vitamin C'], 
    avoid: ['Feta (soft)', 'Raw seafood'], 
    meals: ['Breakfast: Toast with olive oil', 'Lunch: Psarosoupa (fish soup)', 'Dinner: Grilled chicken with vegetables'] 
  },
  
  t1_UK_Irish: { 
    foods: ['Ginger biscuits', 'Crackers', 'Bananas', 'Chicken', 'Hard cheese'], 
    nutrients: ['Folic acid 600mcg', 'Vitamin D', 'Calcium'], 
    avoid: ['Stilton cheese', 'Pâté'], 
    meals: ['Breakfast: Ginger tea with toast', 'Lunch: Chicken broth', 'Dinner: Jacket potato with cheese'] 
  },
  
  t1_North_American: { 
    foods: ['Ginger ale', 'Crackers', 'Bananas', 'Chicken soup', 'Pretzels'], 
    nutrients: ['Folic acid 600mcg', 'Vitamin B6'], 
    avoid: ['Soft cheeses', 'Deli meats'], 
    meals: ['Breakfast: Dry cereal with banana', 'Lunch: Chicken noodle soup', 'Dinner: Baked chicken with rice'] 
  },
  
  t1_Nordic: { 
    foods: ['Ginger', 'Crackers (knäckebröd)', 'Gravlax (cooked)', 'Berries', 'Rye bread'], 
    nutrients: ['Folic acid 600mcg', 'Omega-3', 'Fiber'], 
    avoid: ['Smoked fish (cold)', 'Raw fish'], 
    meals: ['Breakfast: Knäckebröd with butter', 'Lunch: Cooked salmon', 'Dinner: Fish soup'] 
  },
  
  t1_Eastern_European: { 
    foods: ['Ginger tea', 'Crackers', 'Kefir', 'Eggs', 'Pickles'], 
    nutrients: ['Folic acid 600mcg', 'Vitamin B6', 'Probiotics'], 
    avoid: ['Raw fish', 'Unpasteurized milk'], 
    meals: ['Breakfast: Kefir with bread', 'Lunch: Chicken soup', 'Dinner: Eggs with vegetables'] 
  },
  
  t1_Pacific_Islander: { 
    foods: ['Ginger', 'Taro', 'Baked fish', 'Coconut water', 'Breadfruit'], 
    nutrients: ['Folic acid 600mcg', 'Vitamin B6', 'Hydration'], 
    avoid: ['Raw fish (oka)', 'Excess salt'], 
    meals: ['Breakfast: Taro with coconut milk', 'Lunch: Baked fish', 'Dinner: Breadfruit with chicken'] 
  },

  // ========================================
  // TRIMESTER 2 - COMPREHENSIVE 3-DAY MEAL PLANS - All 18 Regions
  // ========================================
  
  t2_West_African: { 
    foods: ['Red meat (beef)', 'Beans (black-eyed peas)', 'Ugu (pumpkin leaves)', 'Milk', 'Groundnuts', 'Plantain', 'Fish (tilapia)', 'Palm oil', 'Okra', 'Egusi seeds'], 
    nutrients: ['Iron 27mg', 'Calcium 1000mg', 'Protein 71g', 'Folate', 'Vitamin A'], 
    avoid: ['Raw meat', 'Bushmeat', 'Excess palm oil'], 
    dailyMeals: {
      day1: {
        breakfast: 'Moi moi (2 pieces) with pap (1 cup) and milk',
        midMorning: 'Groundnuts (handful) with orange',
        lunch: 'Jollof rice (1½ cups) with grilled chicken (palm-size) and fried plantain (3 slices)',
        afternoon: 'Akara (3 pieces) with zobo drink',
        dinner: 'Egusi soup (1 bowl) with pounded yam (small portion)',
        evening: 'Warm milk (1 cup) with dates'
      },
      day2: {
        breakfast: 'Akamu with moi moi (2 pieces)',
        midMorning: 'Roasted plantain with groundnuts',
        lunch: 'Rice and stew with fish (grilled tilapia)',
        afternoon: 'Fresh fruits (papaya, orange)',
        dinner: 'Vegetable soup (ugu) with fufu (small)',
        evening: 'Pap with milk'
      },
      day3: {
        breakfast: 'Yam porridge with fish',
        midMorning: 'Chin-chin with milk',
        lunch: 'Beans and plantain (3 slices)',
        afternoon: 'Fruit salad',
        dinner: 'Okra soup with eba (small portion)',
        evening: 'Groundnut milk'
      }
    }
  },

  t2_East_African: { 
    foods: ['Beef', 'Beans', 'Sukuma wiki', 'Milk', 'Groundnuts', 'Bananas', 'Tilapia', 'Ugali', 'Tomatoes', 'Avocado'], 
    nutrients: ['Iron 27mg', 'Calcium 1000mg', 'Protein 71g', 'Folate', 'Vitamin C'], 
    avoid: ['Raw meat', 'Unpasteurized milk', 'Excess salt'], 
    dailyMeals: {
      day1: {
        breakfast: 'Chai (milk tea) with mandazi (3 pieces)',
        midMorning: 'Roasted groundnuts with banana',
        lunch: 'Nyama choma (grilled beef, palm-size) with ugali and sukuma wiki',
        afternoon: 'Avocado with lemon juice',
        dinner: 'Githeri (beans and corn) with vegetables',
        evening: 'Warm milk (1 cup)'
      },
      day2: {
        breakfast: 'Uji (millet porridge) with milk',
        midMorning: 'Banana with peanuts',
        lunch: 'Pilau rice with chicken and kachumbari salad',
        afternoon: 'Fresh mango slices',
        dinner: 'Matoke (plantain stew) with beans',
        evening: 'Maziwa lala (fermented milk)'
      },
      day3: {
        breakfast: 'Chapati (2) with scrambled eggs',
        midMorning: 'Groundnut cake with chai',
        lunch: 'Fish stew with ugali and spinach',
        afternoon: 'Papaya chunks',
        dinner: 'Bean stew with chapati',
        evening: 'Warm milk with honey'
      }
    }
  },

  t2_North_African: { 
    foods: ['Lamb', 'Lentils', 'Couscous', 'Yogurt', 'Dates', 'Chickpeas', 'Fish', 'Olive oil', 'Almonds', 'Figs'], 
    nutrients: ['Iron 27mg', 'Calcium 1000mg', 'Protein', 'Omega-3', 'Fiber'], 
    avoid: ['Raw meat', 'Unpasteurized cheese', 'Excess spice'], 
    dailyMeals: {
      day1: {
        breakfast: 'Ful medames (fava beans) with olive oil and bread',
        midMorning: 'Dates (4-5) with almonds',
        lunch: 'Lamb tagine with couscous (1½ cups) and vegetable medley',
        afternoon: 'Fresh figs with yogurt',
        dinner: 'Harira soup with bread and boiled eggs',
        evening: 'Warm milk with honey'
      },
      day2: {
        breakfast: 'Msemen (Moroccan flatbread) with honey and cheese',
        midMorning: 'Dried apricots with walnuts',
        lunch: 'Grilled fish with rice and grilled vegetables',
        afternoon: 'Hummus with pita bread',
        dinner: 'Couscous with chickpea stew',
        evening: 'Mint tea with almond cookies'
      },
      day3: {
        breakfast: 'Shakshuka (eggs in tomato sauce) with bread',
        midMorning: 'Date bars',
        lunch: 'Chicken kebabs with tabbouleh and flatbread',
        afternoon: 'Greek yogurt with honey',
        dinner: 'Lentil soup with bread',
        evening: 'Warm milk with cinnamon'
      }
    }
  },

  t2_Southern_African: { 
    foods: ['Beef', 'Beans', 'Morogo (wild spinach)', 'Milk', 'Groundnuts', 'Butternut', 'Fish', 'Maize meal', 'Pumpkin', 'Cabbage'], 
    nutrients: ['Iron 27mg', 'Calcium 1000mg', 'Protein', 'Vitamin A', 'Folate'], 
    avoid: ['Raw meat', 'Unpasteurized milk', 'Excess salt'], 
    dailyMeals: {
      day1: {
        breakfast: 'Soft pap with amasi (soured milk) and sugar',
        midMorning: 'Roasted peanuts with banana',
        lunch: 'Braai meat (grilled beef) with pap, chakalaka, and morogo',
        afternoon: 'Fresh fruit salad',
        dinner: 'Bean stew with samp and spinach',
        evening: 'Warm milk (1 cup)'
      },
      day2: {
        breakfast: 'Pap with milk and peanut butter',
        midMorning: 'Vetkoek (fried bread) with mince',
        lunch: 'Grilled fish with butternut and cabbage salad',
        afternoon: 'Biltong (dried meat) and nuts',
        dinner: 'Oxtail stew with pap',
        evening: 'Maas (fermented milk)'
      },
      day3: {
        breakfast: 'Oats porridge with milk and honey',
        midMorning: 'Roasted mealies (corn)',
        lunch: 'Chicken curry with rice and morogo',
        afternoon: 'Dried fruit mix',
        dinner: 'Samp and beans with vegetables',
        evening: 'Warm milk with rooibos tea'
      }
    }
  },

  t2_Middle_Eastern: { 
    foods: ['Lamb', 'Lentils', 'Chickpeas', 'Labneh', 'Dates', 'Tahini', 'Fish', 'Olive oil', 'Pomegranate', 'Almonds'], 
    nutrients: ['Iron 27mg', 'Calcium 1000mg', 'Protein', 'Healthy fats', 'Fiber'], 
    avoid: ['Raw meat', 'Unpasteurized dairy', 'Excess salt'], 
    dailyMeals: {
      day1: {
        breakfast: 'Labneh with za\'atar, olive oil, and pita bread',
        midMorning: 'Dates (5) with walnuts',
        lunch: 'Lamb kabsa (rice dish) with yogurt and salad',
        afternoon: 'Hummus with vegetable sticks',
        dinner: 'Lentil and rice (mujadara) with fried onions',
        evening: 'Warm milk with cardamom'
      },
      day2: {
        breakfast: 'Foul mudammas with boiled eggs and bread',
        midMorning: 'Halva with tea',
        lunch: 'Grilled fish with freekeh and grilled vegetables',
        afternoon: 'Baba ghanoush with pita',
        dinner: 'Chicken shawarma with tabbouleh',
        evening: 'Chamomile tea with honey'
      },
      day3: {
        breakfast: 'Manakeesh (flatbread) with cheese and za\'atar',
        midMorning: 'Pomegranate seeds with almonds',
        lunch: 'Lamb stew with rice and yogurt',
        afternoon: 'Dates stuffed with tahini',
        dinner: 'Lentil soup with bread and salad',
        evening: 'Warm milk with saffron'
      }
    }
  },

  t2_South_Asian: { 
    foods: ['Mutton', 'Masoor dal', 'Palak (spinach)', 'Dahi (curd)', 'Badam (almonds)', 'Paneer', 'Roti (whole wheat)', 'Ghee', 'Dry fruits', 'Milk'], 
    nutrients: ['Iron 27mg', 'Calcium 1000mg', 'Protein', 'DHA', 'Vitamin B12'], 
    avoid: ['Paan', 'Excess masala', 'Street food', 'Ajinomoto'], 
    dailyMeals: {
      day1: {
        breakfast: 'Paratha (2) with dahi (1 cup) and mango pickle',
        midMorning: 'Dry fruits ladoo (2) with warm milk',
        lunch: 'Mutton rogan josh (1 cup) with rice (1½ cups) and raita',
        afternoon: 'Samosa (1) with mint chutney',
        dinner: 'Dal tadka with roti (3), sabzi and salad',
        evening: 'Badam milk (warm)'
      },
      day2: {
        breakfast: 'Poha with peanuts and curry leaves',
        midMorning: 'Banana with almonds',
        lunch: 'Chicken curry with rice and palak paneer',
        afternoon: 'Pakoras with chai',
        dinner: 'Khichdi with ghee and dahi',
        evening: 'Haldi doodh (turmeric milk)'
      },
      day3: {
        breakfast: 'Idli (4) with sambar and coconut chutney',
        midMorning: 'Fruit chaat',
        lunch: 'Biryani with raita and curry',
        afternoon: 'Chana chaat',
        dinner: 'Roti with dal and sabzi',
        evening: 'Warm milk with saffron'
      }
    }
  },

  t2_East_Asian: { 
    foods: ['Pork', 'Tofu', 'Bok choy', 'Eggs', 'Sesame seeds', 'Fish', 'Brown rice', 'Seaweed', 'Red dates', 'Soy milk'], 
    nutrients: ['Iron 27mg', 'Calcium 1000mg', 'Protein', 'Iodine', 'DHA'], 
    avoid: ['Raw fish', 'High-mercury fish', 'Cold foods'], 
    dailyMeals: {
      day1: {
        breakfast: 'Congee with preserved eggs and pork floss',
        midMorning: 'Red date tea with sesame cookies',
        lunch: 'Braised pork belly with rice (1½ cups) and stir-fried bok choy',
        afternoon: 'Steamed egg custard',
        dinner: 'Fish soup with tofu and vegetables',
        evening: 'Warm soy milk with red dates'
      },
      day2: {
        breakfast: 'Steamed buns (baozi) with pork filling',
        midMorning: 'Walnut and red date paste',
        lunch: 'Chicken and mushroom stir-fry with brown rice',
        afternoon: 'Tofu pudding with ginger syrup',
        dinner: 'Seaweed soup with fish and rice',
        evening: 'Black sesame soup'
      },
      day3: {
        breakfast: 'Jianbing (Chinese crepe) with egg',
        midMorning: 'Dried longan with nuts',
        lunch: 'Sweet and sour fish with rice and vegetables',
        afternoon: 'Red bean soup',
        dinner: 'Braised tofu with minced pork and rice',
        evening: 'Warm soy milk'
      }
    }
  },

  t2_Southeast_Asian: { 
    foods: ['Chicken', 'Tempeh', 'Kangkung (water spinach)', 'Coconut milk', 'Peanuts', 'Fish', 'Rice', 'Papaya (ripe)', 'Moringa', 'Eggs'], 
    nutrients: ['Iron 27mg', 'Calcium 1000mg', 'Protein', 'Vitamin C', 'Folate'], 
    avoid: ['Raw papaya', 'Raw seafood', 'Excess chili'], 
    dailyMeals: {
      day1: {
        breakfast: 'Nasi lemak (coconut rice) with sambal and boiled egg',
        midMorning: 'Pisang goreng (fried banana) with peanuts',
        lunch: 'Ayam masak merah (chicken in tomato sauce) with rice and stir-fried kangkung',
        afternoon: 'Ripe papaya slices',
        dinner: 'Tempeh curry with rice and sayur lodeh (vegetable soup)',
        evening: 'Warm ginger tea with palm sugar'
      },
      day2: {
        breakfast: 'Bubur ayam (chicken porridge) with century egg',
        midMorning: 'Kuih (traditional cakes) with coconut',
        lunch: 'Grilled fish with turmeric rice and gado-gado salad',
        afternoon: 'Fresh young coconut water with fruit',
        dinner: 'Beef rendang (mild) with rice and vegetables',
        evening: 'Warm milk with honey'
      },
      day3: {
        breakfast: 'Roti canai with dal curry',
        midMorning: 'Onde-onde (glutinous rice balls) with coconut',
        lunch: 'Sinigang (sour soup) with fish and rice',
        afternoon: 'Fruit salad with coconut cream',
        dinner: 'Chicken adobo with rice and moringa soup',
        evening: 'Malunggay (moringa) tea'
      }
    }
  },

  t2_Mexican: { 
    foods: ['Beef', 'Black beans', 'Nopales', 'Queso fresco (pasteurized)', 'Avocado', 'Chicken', 'Corn tortillas', 'Tomatoes', 'Chia seeds', 'Milk'], 
    nutrients: ['Iron 27mg', 'Calcium 1000mg', 'Protein', 'Fiber', 'Folate'], 
    avoid: ['Unpasteurized cheese', 'Raw chorizo', 'Excess spice'], 
    dailyMeals: {
      day1: {
        breakfast: 'Chilaquiles with eggs and refried beans',
        midMorning: 'Papaya chunks with chia seeds',
        lunch: 'Carne asada (grilled beef) with rice, beans, and nopales salad',
        afternoon: 'Quesadilla with cheese and avocado',
        dinner: 'Chicken pozole with tostadas',
        evening: 'Warm atole (corn-based drink)'
      },
      day2: {
        breakfast: 'Huevos rancheros with tortillas and beans',
        midMorning: 'Guava slices with queso fresco',
        lunch: 'Chicken mole (mild) with rice and tortillas',
        afternoon: 'Elote (grilled corn) with lime',
        dinner: 'Bean and cheese burrito with salsa verde',
        evening: 'Warm milk with cinnamon'
      },
      day3: {
        breakfast: 'Molletes (beans and cheese on bread)',
        midMorning: 'Mango with chili-lime seasoning',
        lunch: 'Pescado a la veracruzana (fish in tomato sauce) with rice',
        afternoon: 'Avocado toast on corn tortilla',
        dinner: 'Enchiladas with chicken, beans, and salad',
        evening: 'Chamomile tea with honey'
      }
    }
  },

  t2_South_American: { 
    foods: ['Beef', 'Black beans', 'Quinoa', 'Cheese', 'Avocado', 'Chicken', 'Plantain', 'Tomatoes', 'Papaya', 'Milk'], 
    nutrients: ['Iron 27mg', 'Calcium 1000mg', 'Protein', 'Fiber', 'Omega-3'], 
    avoid: ['Unpasteurized cheese', 'Raw meat', 'Excess salt'], 
    dailyMeals: {
      day1: {
        breakfast: 'Arepas with scrambled eggs and cheese',
        midMorning: 'Papaya smoothie with oats',
        lunch: 'Asado (grilled beef) with quinoa, black beans, and salad',
        afternoon: 'Empanada (baked) with cheese',
        dinner: 'Feijoada (bean stew) with rice and orange slices',
        evening: 'Warm milk with honey'
      },
      day2: {
        breakfast: 'Pão de queijo (cheese bread) with coffee and milk',
        midMorning: 'Guava paste with cheese',
        lunch: 'Pollo a la brasa (rotisserie chicken) with rice and plantains',
        afternoon: 'Avocado smoothie',
        dinner: 'Quinoa soup with vegetables and chicken',
        evening: 'Chamomile tea'
      },
      day3: {
        breakfast: 'Scrambled eggs with beans and avocado',
        midMorning: 'Acai bowl with granola',
        lunch: 'Churrasco (grilled meat) with rice, beans, and farofa',
        afternoon: 'Fried plantain with cheese',
        dinner: 'Chicken and vegetable stew with rice',
        evening: 'Warm milk with cinnamon'
      }
    }
  },

  t2_Central_American: { 
    foods: ['Beef', 'Black beans', 'Corn', 'Cheese', 'Plantain', 'Chicken', 'Tortillas', 'Papaya', 'Avocado', 'Milk'], 
    nutrients: ['Iron 27mg', 'Calcium 1000mg', 'Protein', 'Fiber', 'Vitamin C'], 
    avoid: ['Unpasteurized cheese', 'Raw meat', 'Street food'], 
    dailyMeals: {
      day1: {
        breakfast: 'Gallo pinto (rice and beans) with scrambled eggs and tortilla',
        midMorning: 'Ripe plantain with cheese',
        lunch: 'Carne asada with rice, beans, and cabbage salad',
        afternoon: 'Fresh papaya chunks',
        dinner: 'Sopa de res (beef soup) with vegetables and tortillas',
        evening: 'Warm milk with vanilla'
      },
      day2: {
        breakfast: 'Casamiento (rice and beans) with fried plantain',
        midMorning: 'Pupusa with cheese and beans',
        lunch: 'Pollo guisado (stewed chicken) with rice and salad',
        afternoon: 'Atol de elote (corn drink) with bread',
        dinner: 'Bean and cheese quesadilla with pico de gallo',
        evening: 'Chamomile tea'
      },
      day3: {
        breakfast: 'Tortilla with eggs and refried beans',
        midMorning: 'Mango slices with lime',
        lunch: 'Grilled fish with rice, beans, and fried plantain',
        afternoon: 'Avocado with salt and lime',
        dinner: 'Chicken tamales with cream and salad',
        evening: 'Warm milk with cinnamon'
      }
    }
  },

  t2_Caribbean: { 
    foods: ['Chicken', 'Red peas', 'Callaloo', 'Cheese', 'Green banana', 'Fish', 'Rice', 'Plantain', 'Coconut', 'Milk'], 
    nutrients: ['Iron 27mg', 'Calcium 1000mg', 'Protein', 'Omega-3', 'Vitamin C'], 
    avoid: ['Raw fish', 'Unpasteurized juice', 'Excess salt'], 
    dailyMeals: {
      day1: {
        breakfast: 'Ackee and saltfish with boiled green banana and dumplings',
        midMorning: 'Coconut water with plantain chips',
        lunch: 'Jerk chicken with rice and peas, and steamed callaloo',
        afternoon: 'Gizzada (coconut tart)',
        dinner: 'Brown stew fish with white rice and steamed vegetables',
        evening: 'Warm milk with nutmeg'
      },
      day2: {
        breakfast: 'Callaloo with boiled provisions (yam, banana, dumplings)',
        midMorning: 'Fresh mango slices',
        lunch: 'Curry goat with rice, beans, and coleslaw',
        afternoon: 'Coconut drops (sweet)',
        dinner: 'Chicken soup with ground provisions',
        evening: 'Sorrel drink (warm)'
      },
      day3: {
        breakfast: 'Saltfish fritters with festival (fried dough)',
        midMorning: 'Papaya with lime',
        lunch: 'Oxtail with butter beans, rice, and fried plantain',
        afternoon: 'Bulla cake with cheese',
        dinner: 'Steamed fish with okra and rice',
        evening: 'Warm milk with vanilla'
      }
    }
  },

  t2_Mediterranean: { 
    foods: ['Lamb', 'Lentils', 'Spinach', 'Greek yogurt', 'Feta cheese', 'Olive oil', 'Fish (sardines)', 'Chickpeas', 'Tomatoes', 'Almonds'], 
    nutrients: ['Iron 27mg', 'Calcium 1000mg', 'Omega-3', 'Protein', 'Vitamin D'], 
    avoid: ['Raw seafood', 'Soft feta', 'Excess salt'], 
    dailyMeals: {
      day1: {
        breakfast: 'Greek yogurt (1 cup) with honey (1 tbsp), walnuts (6-8 halves) and berries',
        midMorning: 'Whole grain pita with hummus (¼ cup)',
        lunch: 'Moussaka (1 serving) with Greek salad (olive oil dressing)',
        afternoon: 'Almonds (10-12) with dried figs (2)',
        dinner: 'Grilled fish (palm-size) with roasted vegetables and quinoa (1 cup)',
        evening: 'Warm milk with honey'
      },
      day2: {
        breakfast: 'Shakshuka (2 eggs) with whole grain bread',
        midMorning: 'Fresh fruit with Greek yogurt',
        lunch: 'Lentil soup with Greek salad',
        afternoon: 'Tzatziki with vegetable sticks',
        dinner: 'Lamb souvlaki with tabbouleh',
        evening: 'Chamomile tea with biscotti'
      },
      day3: {
        breakfast: 'Mediterranean omelet with feta and spinach',
        midMorning: 'Dates stuffed with almonds',
        lunch: 'Stuffed grape leaves with lemon chicken',
        afternoon: 'Olives and cheese with crackers',
        dinner: 'Baked fish with Greek potatoes',
        evening: 'Greek yogurt with honey'
      }
    }
  },

  t2_UK_Irish: { 
    foods: ['Beef', 'Baked beans', 'Spinach', 'Milk', 'Cheddar cheese', 'Salmon', 'Oats', 'Eggs', 'Berries', 'Whole grain bread'], 
    nutrients: ['Iron 27mg', 'Calcium 1000mg', 'Omega-3', 'Vitamin D', 'Protein'], 
    avoid: ['Soft cheeses', 'Pâté', 'Liver'], 
    dailyMeals: {
      day1: {
        breakfast: 'Porridge with milk, berries, and honey',
        midMorning: 'Cheese and crackers',
        lunch: 'Shepherd\'s pie with mixed vegetables',
        afternoon: 'Scone with butter and jam',
        dinner: 'Baked salmon with mashed potatoes and green beans',
        evening: 'Warm milk with honey'
      },
      day2: {
        breakfast: 'Full Irish breakfast (eggs, beans, mushrooms, tomatoes, toast)',
        midMorning: 'Apple slices with peanut butter',
        lunch: 'Beef stew with carrots and potatoes',
        afternoon: 'Flapjack (oat bar)',
        dinner: 'Chicken and leek pie with mashed potatoes',
        evening: 'Horlicks (malted milk drink)'
      },
      day3: {
        breakfast: 'Scrambled eggs on wholegrain toast with grilled tomatoes',
        midMorning: 'Yogurt with granola',
        lunch: 'Fish and chips (baked fish, oven chips) with mushy peas',
        afternoon: 'Digestive biscuits with tea',
        dinner: 'Roast chicken with roasted vegetables and gravy',
        evening: 'Warm milk with nutmeg'
      }
    }
  },

  t2_North_American: { 
    foods: ['Beef', 'Black beans', 'Spinach', 'Milk', 'Cheddar cheese', 'Salmon', 'Oats', 'Eggs', 'Berries', 'Whole grain bread'], 
    nutrients: ['Iron 27mg', 'Calcium 1000mg', 'Omega-3', 'Vitamin D', 'Protein'], 
    avoid: ['Soft cheeses', 'Deli meats', 'Raw eggs'], 
    dailyMeals: {
      day1: {
        breakfast: 'Oatmeal with milk, blueberries, and walnuts',
        midMorning: 'Greek yogurt with granola',
        lunch: 'Grilled chicken sandwich with avocado, lettuce, tomato, and side salad',
        afternoon: 'Trail mix (nuts and dried fruit)',
        dinner: 'Baked salmon with quinoa and roasted broccoli',
        evening: 'Warm milk with vanilla'
      },
      day2: {
        breakfast: 'Scrambled eggs with whole wheat toast and orange juice',
        midMorning: 'Apple slices with almond butter',
        lunch: 'Turkey burger with sweet potato fries and coleslaw',
        afternoon: 'Cheese and whole grain crackers',
        dinner: 'Beef tacos with black beans, cheese, and salsa',
        evening: 'Chamomile tea with honey'
      },
      day3: {
        breakfast: 'Whole grain pancakes with berries and maple syrup',
        midMorning: 'Smoothie (banana, spinach, milk, protein powder)',
        lunch: 'Chicken Caesar salad with whole grain bread',
        afternoon: 'Hummus with carrot and celery sticks',
        dinner: 'Meatloaf with mashed potatoes and green beans',
        evening: 'Warm milk with cinnamon'
      }
    }
  },

  t2_Nordic: { 
    foods: ['Salmon', 'Herring', 'Root vegetables', 'Milk', 'Cheese', 'Rye bread', 'Eggs', 'Berries (lingonberries)', 'Oats', 'Potatoes'], 
    nutrients: ['Iron 27mg', 'Calcium 1000mg', 'Omega-3', 'Vitamin D', 'Protein'], 
    avoid: ['Raw fish', 'Smoked fish (cold)', 'Excess salt'], 
    dailyMeals: {
      day1: {
        breakfast: 'Rye bread with smoked salmon (cooked), cream cheese, and cucumber',
        midMorning: 'Filmjölk (fermented milk) with granola',
        lunch: 'Gravlax (cured salmon, cooked version) with potatoes and dill sauce',
        afternoon: 'Knäckebröd with cheese',
        dinner: 'Swedish meatballs with lingonberry sauce, potatoes, and vegetables',
        evening: 'Warm milk with cardamom'
      },
      day2: {
        breakfast: 'Oatmeal porridge with milk and berries',
        midMorning: 'Cinnamon bun (kanelbulle) with milk',
        lunch: 'Pan-fried herring with beetroot salad and boiled potatoes',
        afternoon: 'Yogurt with lingonberry jam',
        dinner: 'Baked cod with root vegetables and butter sauce',
        evening: 'Warm blueberry soup'
      },
      day3: {
        breakfast: 'Open-faced sandwich with egg, tomato, and cheese on rye',
        midMorning: 'Apple with almond butter',
        lunch: 'Salmon soup with potatoes and dill',
        afternoon: 'Rice pudding with cinnamon',
        dinner: 'Reindeer stew (or beef) with mashed potatoes and lingonberries',
        evening: 'Warm milk with honey'
      }
    }
  },

  t2_Eastern_European: { 
    foods: ['Beef', 'Buckwheat', 'Beets', 'Sour cream', 'Eggs', 'Fish', 'Cabbage', 'Potatoes', 'Kefir', 'Cottage cheese'], 
    nutrients: ['Iron 27mg', 'Calcium 1000mg', 'Protein', 'Probiotics', 'Vitamin C'], 
    avoid: ['Raw fish', 'Unpasteurized dairy', 'Excess salt'], 
    dailyMeals: {
      day1: {
        breakfast: 'Syrniki (cottage cheese pancakes) with sour cream and jam',
        midMorning: 'Kefir with honey',
        lunch: 'Beef stroganoff with buckwheat and pickled vegetables',
        afternoon: 'Blini (thin pancakes) with cottage cheese',
        dinner: 'Borscht (beet soup) with bread and boiled eggs',
        evening: 'Warm milk with honey'
      },
      day2: {
        breakfast: 'Kasha (buckwheat porridge) with milk and butter',
        midMorning: 'Apple with cottage cheese',
        lunch: 'Chicken Kiev with mashed potatoes and sauerkraut',
        afternoon: 'Pirozhki (baked pastries) with meat filling',
        dinner: 'Fish in sour cream sauce with rice and vegetables',
        evening: 'Chamomile tea'
      },
      day3: {
        breakfast: 'Oladyi (small pancakes) with sour cream',
        midMorning: 'Kefir with berries',
        lunch: 'Golubtsy (stuffed cabbage rolls) with tomato sauce',
        afternoon: 'Cottage cheese with honey',
        dinner: 'Pelmeni (dumplings with meat) with sour cream',
        evening: 'Warm milk with vanilla'
      }
    }
  },

  t2_Pacific_Islander: { 
    foods: ['Fish', 'Chicken', 'Taro', 'Coconut', 'Sweet potato', 'Breadfruit', 'Plantain', 'Green leafy vegetables', 'Eggs', 'Papaya'], 
    nutrients: ['Iron 27mg', 'Calcium 1000mg', 'Protein', 'Vitamin A', 'Fiber'], 
    avoid: ['Raw fish', 'Excess salt', 'Processed foods'], 
    dailyMeals: {
      day1: {
        breakfast: 'Taro with coconut cream and baked fish',
        midMorning: 'Fresh papaya slices',
        lunch: 'Lovo (earth oven) chicken with sweet potato, taro, and cassava',
        afternoon: 'Roasted breadfruit with coconut',
        dinner: 'Fish soup with taro leaves and coconut milk',
        evening: 'Warm coconut water'
      },
      day2: {
        breakfast: 'Boiled green banana with coconut milk',
        midMorning: 'Fresh pineapple chunks',
        lunch: 'Palusami (taro leaves with coconut cream) and baked fish',
        afternoon: 'Roasted plantain',
        dinner: 'Chicken curry with rice and vegetables',
        evening: 'Warm milk with honey'
      },
      day3: {
        breakfast: 'Breadfruit porridge with coconut milk',
        midMorning: 'Mango slices',
        lunch: 'Grilled fish with taro, sweet potato, and island greens',
        afternoon: 'Coconut buns',
        dinner: 'Sapasui (noodle dish) with chicken and vegetables',
        evening: 'Chamomile tea'
      }
    }
  },

  // ========================================
  // TRIMESTER 3 - All 18 Regions
  // ========================================
  
  t3_West_African: { 
    foods: ['Fish (mackerel)', 'Chicken', 'Vegetable soup', 'Dates', 'Water'], 
    nutrients: ['Iron', 'Calcium', 'Vitamin K', 'Fiber'], 
    avoid: ['Excess pepper', 'Large portions'], 
    meals: ['Breakfast: Akamu (pap) with milk', 'Lunch: Light soup with fish', 'Dinner: Vegetable soup with small portion'] 
  },
  
  t3_East_African: { 
    foods: ['Tilapia', 'Chicken', 'Sukuma wiki', 'Dates', 'Water'], 
    nutrients: ['Protein', 'Fiber', 'Hydration'], 
    avoid: ['Excess salt', 'Heavy meals'], 
    meals: ['Breakfast: Uji (porridge)', 'Lunch: Grilled tilapia with vegetables', 'Dinner: Light chicken soup'] 
  },
  
  t3_North_African: { 
    foods: ['Grilled fish', 'Chicken', 'Couscous', 'Dates', 'Water'], 
    nutrients: ['Protein', 'Fiber', 'Vitamin K'], 
    avoid: ['Large meals', 'Spicy food'], 
    meals: ['Breakfast: Dates with milk', 'Lunch: Grilled fish with light couscous', 'Dinner: Chicken soup'] 
  },
  
  t3_Southern_African: { 
    foods: ['Fish', 'Chicken', 'Butternut', 'Dates', 'Water'], 
    nutrients: ['Protein', 'Fiber', 'Vitamin A'], 
    avoid: ['Large portions', 'Excess salt'], 
    meals: ['Breakfast: Soft pap', 'Lunch: Grilled fish with butternut', 'Dinner: Light chicken soup'] 
  },
  
  t3_Middle_Eastern: { 
    foods: ['Grilled chicken', 'Fish', 'Dates', 'Vegetables', 'Water'], 
    nutrients: ['Protein', 'Fiber', 'Vitamin K'], 
    avoid: ['Excess salt', 'Large meals'], 
    meals: ['Breakfast: Labneh with dates', 'Lunch: Grilled fish with vegetables', 'Dinner: Light soup'] 
  },
  
  t3_South_Asian: { 
    foods: ['Fish', 'Chicken', 'Methi (fenugreek leaves)', 'Dates', 'Coconut water'], 
    nutrients: ['Protein', 'Fiber', 'Hydration'], 
    avoid: ['Excess spice', 'Fried foods'], 
    meals: ['Breakfast: Idli with coconut chutney', 'Lunch: Fish curry (mild) with rice', 'Dinner: Dal with roti'] 
  },
  
  t3_East_Asian: { 
    foods: ['Fish', 'Chicken soup', 'Vegetables', 'Red dates'], 
    nutrients: ['Protein', 'Fiber', 'Iron'], 
    avoid: ['Cold foods', 'Spicy foods'], 
    meals: ['Breakfast: Vegetable noodle soup', 'Lunch: Steamed chicken with vegetables', 'Dinner: Fish congee'] 
  },
  
  t3_Southeast_Asian: { 
    foods: ['Fish', 'Chicken', 'Vegetables', 'Coconut water'], 
    nutrients: ['Protein', 'Fiber', 'Hydration'], 
    avoid: ['Spicy foods', 'Large meals'], 
    meals: ['Breakfast: Rice porridge', 'Lunch: Steamed fish with vegetables', 'Dinner: Light chicken soup'] 
  },
  
  t3_Mexican: { 
    foods: ['Grilled chicken', 'Fish', 'Beans', 'Vegetables', 'Water'], 
    nutrients: ['Protein', 'Fiber', 'Iron'], 
    avoid: ['Excess salt', 'Spicy foods'], 
    meals: ['Breakfast: Scrambled eggs with beans', 'Lunch: Grilled fish with salad', 'Dinner: Chicken soup'] 
  },
  
  t3_South_American: { 
    foods: ['Grilled chicken', 'Fish', 'Beans', 'Vegetables', 'Water'], 
    nutrients: ['Protein', 'Fiber', 'Omega-3'], 
    avoid: ['Large meals', 'Spicy foods'], 
    meals: ['Breakfast: Eggs with beans', 'Lunch: Grilled fish', 'Dinner: Light chicken soup'] 
  },
  
  t3_Central_American: { 
    foods: ['Chicken', 'Fish', 'Black beans', 'Plantain', 'Water'], 
    nutrients: ['Protein', 'Fiber', 'Potassium'], 
    avoid: ['Large meals', 'Excess salt'], 
    meals: ['Breakfast: Gallo pinto', 'Lunch: Grilled fish with plantain', 'Dinner: Light soup'] 
  },
  
  t3_Caribbean: { 
    foods: ['Fish', 'Chicken', 'Vegetables', 'Coconut water'], 
    nutrients: ['Protein', 'Omega-3', 'Fiber'], 
    avoid: ['Excess salt', 'Large meals'], 
    meals: ['Breakfast: Boiled green banana', 'Lunch: Grilled fish', 'Dinner: Light chicken soup'] 
  },
  
  t3_Mediterranean: { 
    foods: ['Fish', 'Chicken', 'Leafy greens', 'Dates', 'Olive oil'], 
    nutrients: ['Omega-3', 'Vitamin K', 'Fiber'], 
    avoid: ['Large meals', 'Excess salt'], 
    meals: ['Breakfast: Greek yogurt with dates', 'Lunch: Grilled fish with horiatiki', 'Dinner: Light soup'] 
  },
  
  t3_UK_Irish: { 
    foods: ['Fish', 'Chicken', 'Leafy greens', 'Dates'], 
    nutrients: ['Iron', 'Omega-3', 'Vitamin K'], 
    avoid: ['Excess salt', 'Lying down after eating'], 
    meals: ['Breakfast: Porridge with berries', 'Lunch: Chicken salad', 'Dinner: Light fish soup'] 
  },
  
  t3_North_American: { 
    foods: ['Fish', 'Chicken', 'Leafy greens', 'Dates'], 
    nutrients: ['Omega-3', 'Fiber', 'Iron'], 
    avoid: ['Large meals', 'Excess salt'], 
    meals: ['Breakfast: Whole grain toast with avocado', 'Lunch: Grilled chicken salad', 'Dinner: Light soup'] 
  },
  
  t3_Nordic: { 
    foods: ['Salmon', 'Chicken', 'Root vegetables', 'Berries'], 
    nutrients: ['Omega-3', 'Fiber', 'Vitamin C'], 
    avoid: ['Large meals', 'Excess salt'], 
    meals: ['Breakfast: Rye bread with salmon', 'Lunch: Baked salmon with vegetables', 'Dinner: Light fish soup'] 
  },
  
  t3_Eastern_European: { 
    foods: ['Fish', 'Chicken', 'Vegetables', 'Kefir'], 
    nutrients: ['Protein', 'Fiber', 'Probiotics'], 
    avoid: ['Large meals', 'Excess salt'], 
    meals: ['Breakfast: Kefir with bread', 'Lunch: Baked fish', 'Dinner: Light chicken soup'] 
  },
  
  t3_Pacific_Islander: { 
    foods: ['Fish', 'Chicken', 'Taro', 'Vegetables', 'Coconut water'], 
    nutrients: ['Protein', 'Fiber', 'Hydration'], 
    avoid: ['Excess salt', 'Large meals'], 
    meals: ['Breakfast: Taro with fish', 'Lunch: Grilled chicken', 'Dinner: Light fish soup'] 
  },

  // ========================================
  // POSTPARTUM - All 18 Regions
  // ========================================
  
  postpartum_West_African: { 
    foods: ['Pap (ogi)', 'Pepper soup (light)', 'Tilapia', 'Vegetables', 'Water'], 
    nutrients: ['Protein', 'Iron', 'Calcium', 'Hydration'], 
    avoid: ['Alcohol', 'Excess pepper'], 
    meals: ['Breakfast: Pap with milk and groundnuts', 'Lunch: Pepper soup with fish', 'Dinner: Light vegetable soup'], 
    breastfeeding: ['Drink 8-10 glasses water daily', 'Eat pap', 'Pepper soup boosts milk'] 
  },
  
  postpartum_East_African: { 
    foods: ['Ugali', 'Chicken soup', 'Tilapia', 'Sukuma wiki', 'Millet porridge'], 
    nutrients: ['Protein', 'Iron', 'Traditional foods'], 
    avoid: ['Cold foods', 'Excess caffeine'], 
    meals: ['Breakfast: Millet porridge', 'Lunch: Chicken soup', 'Dinner: Ugali with vegetables'], 
    breastfeeding: ['Stay hydrated', 'Eat traditional foods', 'Millet porridge'] 
  },
  
  postpartum_North_African: { 
    foods: ['Harira soup', 'Dates', 'Almonds', 'Chicken', 'Olive oil'], 
    nutrients: ['Protein', 'Healthy fats', 'Iron'], 
    avoid: ['Alcohol', 'Cold foods'], 
    meals: ['Breakfast: Dates with milk', 'Lunch: Harira with bread', 'Dinner: Chicken tagine'], 
    breastfeeding: ['Eat dates daily', 'Almond paste', 'Helba (fenugreek) tea'] 
  },
  
  postpartum_Southern_African: { 
    foods: ['Soft pap', 'Chicken soup', 'Fish', 'Morogo', 'Amasi'], 
    nutrients: ['Protein', 'Probiotics', 'Iron'], 
    avoid: ['Alcohol', 'Spicy foods'], 
    meals: ['Breakfast: Soft pap with amasi', 'Lunch: Chicken soup', 'Dinner: Fish with vegetables'], 
    breastfeeding: ['Drink plenty water', 'Traditional foods', 'Amasi (soured milk)'] 
  },
  
  postpartum_Middle_Eastern: { 
    foods: ['Chicken soup', 'Dates', 'Almonds', 'Halva', 'Water'], 
    nutrients: ['Protein', 'Calcium', 'Healthy fats'], 
    avoid: ['Alcohol', 'Excess caffeine'], 
    meals: ['Breakfast: Dates with milk', 'Lunch: Chicken soup', 'Dinner: Lentil soup'], 
    breastfeeding: ['Stay hydrated', 'Eat halva', 'Caraway tea'] 
  },
  
  postpartum_South_Asian: { 
    foods: ['Ghee', 'Almonds (badam)', 'Dates', 'Moong dal', 'Ginger'], 
    nutrients: ['Protein', 'Healthy fats', 'Iron'], 
    avoid: ['Cold water', 'Sour foods'], 
    meals: ['Breakfast: Panjiri or almond halwa', 'Lunch: Dal with ghee and rice', 'Dinner: Khichdi with ghee'], 
    breastfeeding: ['Drink warm water only', 'Methi laddoo', 'Ajwain water', 'Sauf (fennel) water'] 
  },
  
  postpartum_East_Asian: { 
    foods: ['Chicken soup', 'Fish soup', 'Ginger dishes', 'Red dates'], 
    nutrients: ['Protein', 'Iron', 'Warming foods'], 
    avoid: ['Cold foods', 'Raw foods'], 
    meals: ['Breakfast: Chicken congee with ginger', 'Lunch: Fish soup', 'Dinner: Chicken soup with red dates'], 
    breastfeeding: ['Papaya soup', 'Warm water only', 'Confinement foods'] 
  },
  
  postpartum_Southeast_Asian: { 
    foods: ['Chicken soup', 'Fish', 'Ginger', 'Turmeric', 'Coconut'], 
    nutrients: ['Protein', 'Warming spices', 'Iron'], 
    avoid: ['Cold foods', 'Raw vegetables'], 
    meals: ['Breakfast: Rice porridge with chicken', 'Lunch: Fish curry', 'Dinner: Chicken soup with turmeric'], 
    breastfeeding: ['Stay hydrated', 'Papaya soup', 'Jamu drinks'] 
  },
  
  postpartum_Mexican: { 
    foods: ['Caldo de pollo', 'Atole', 'Tortillas', 'Beans', 'Avocado'], 
    nutrients: ['Protein', 'Healthy fats', 'Iron'], 
    avoid: ['Alcohol', 'Very spicy foods'], 
    meals: ['Breakfast: Atole with tamales', 'Lunch: Caldo de pollo', 'Dinner: Bean soup'], 
    breastfeeding: ['Drink plenty water', 'Atole', 'Caldo (warm soups)'] 
  },
  
  postpartum_South_American: { 
    foods: ['Chicken soup', 'Beans', 'Avocado', 'Eggs', 'Water'], 
    nutrients: ['Protein', 'Iron', 'Healthy fats'], 
    avoid: ['Alcohol', 'Excess caffeine'], 
    meals: ['Breakfast: Eggs with beans', 'Lunch: Chicken soup', 'Dinner: Bean stew'], 
    breastfeeding: ['Drink plenty water', 'Eat oats', 'Warm teas'] 
  },
  
  postpartum_Central_American: { 
    foods: ['Chicken soup', 'Beans', 'Tortillas', 'Plantain'], 
    nutrients: ['Protein', 'Iron', 'Fiber'], 
    avoid: ['Alcohol', 'Cold drinks'], 
    meals: ['Breakfast: Gallo pinto', 'Lunch: Chicken soup', 'Dinner: Bean soup'], 
    breastfeeding: ['Drink plenty water', 'Traditional soups', 'Warm drinks'] 
  },
  
  postpartum_Caribbean: { 
    foods: ['Fish tea', 'Mannish water', 'Chicken soup', 'Coconut water'], 
    nutrients: ['Protein', 'Hydration', 'Traditional foods'], 
    avoid: ['Alcohol', 'Very cold drinks'], 
    meals: ['Breakfast: Fish tea', 'Lunch: Mannish water or chicken soup', 'Dinner: Chicken soup'], 
    breastfeeding: ['Drink coconut water', 'Fish tea', 'Bush teas'] 
  },
  
  postpartum_Mediterranean: { 
    foods: ['Fish soup', 'Chicken', 'Lentils', 'Olive oil', 'Water'], 
    nutrients: ['Protein', 'Omega-3', 'Iron'], 
    avoid: ['Alcohol', 'Excess caffeine'], 
    meals: ['Breakfast: Greek yogurt with nuts', 'Lunch: Avgolemono soup', 'Dinner: Fish soup'], 
    breastfeeding: ['Stay hydrated', 'Eat oily fish', 'Fennel tea'] 
  },
  
  postpartum_UK_Irish: { 
    foods: ['Oats', 'Lean meats', 'Leafy greens', 'Water'], 
    nutrients: ['Protein', 'Iron', 'Omega-3'], 
    avoid: ['Alcohol', 'Excess caffeine'], 
    meals: ['Breakfast: Porridge with berries', 'Lunch: Chicken soup', 'Dinner: Salmon with vegetables'], 
    breastfeeding: ['Stay hydrated', 'Eat oats and almonds', 'Lactation teas'] 
  },
  
  postpartum_North_American: { 
    foods: ['Oats', 'Lean meats', 'Leafy greens', 'Water'], 
    nutrients: ['Protein', 'Iron', 'Fiber'], 
    avoid: ['Alcohol', 'Excess caffeine'], 
    meals: ['Breakfast: Oatmeal with berries', 'Lunch: Turkey sandwich', 'Dinner: Chicken salad'], 
    breastfeeding: ['Stay hydrated', 'Eat oats and almonds', 'Lactation cookies'] 
  },
  
  postpartum_Nordic: { 
    foods: ['Salmon', 'Rye bread', 'Berries', 'Kefir'], 
    nutrients: ['Omega-3', 'Probiotics', 'Vitamin D'], 
    avoid: ['Alcohol', 'Excess caffeine'], 
    meals: ['Breakfast: Rye bread with salmon', 'Lunch: Fish soup', 'Dinner: Baked salmon'], 
    breastfeeding: ['Stay hydrated', 'Eat oily fish', 'Berry teas'] 
  },
  
  postpartum_Eastern_European: { 
    foods: ['Chicken soup', 'Kefir', 'Buckwheat', 'Fish'], 
    nutrients: ['Protein', 'Probiotics', 'Iron'], 
    avoid: ['Alcohol', 'Excess caffeine'], 
    meals: ['Breakfast: Kefir with bread', 'Lunch: Chicken soup', 'Dinner: Fish with buckwheat'], 
    breastfeeding: ['Drink plenty water', 'Kefir daily', 'Traditional soups'] 
  },
  
  postpartum_Pacific_Islander: { 
    foods: ['Fish soup', 'Chicken', 'Taro', 'Coconut', 'Water'], 
    nutrients: ['Protein', 'Traditional foods', 'Hydration'], 
    avoid: ['Alcohol', 'Cold foods'], 
    meals: ['Breakfast: Taro with coconut milk', 'Lunch: Fish soup', 'Dinner: Chicken soup'], 
    breastfeeding: ['Drink coconut water', 'Eat traditional foods', 'Stay hydrated'] 
  }
};

// Helper function to get nutrition plan based on stage, trimester, and culture
export const getNutritionPlan = (stage, trimester, culture) => {
  // Build lookup key
  let key = stage === 'preconception' ? `preconception_${culture}` : 
            stage === 'pregnant' ? `t${trimester}_${culture}` : 
            `postpartum_${culture}`;
  
  // Fallback to West African if specific region not found
  return nutritionPlans[key] || 
         nutritionPlans[`${stage === 'preconception' ? 'preconception' : stage === 'pregnant' ? `t${trimester}` : 'postpartum'}_West_African`] || 
         nutritionPlans.preconception_West_African;
};
